import React from "react";
import { useTable } from "react-table";
import moment from "moment-ferie-fr";

import { displayAmount } from "../../functions/numbers";

function prepareTable(pd, isProfit, headlessWeekContents) {
  return React.useMemo(
    () => [
      {
        Header: isProfit ? "Profit" : "Pertes",
        accessor: "isProfit",
        columns: [
          {
            Header: pd,
            accessor: "produit",
            Cell: ({ row }) => {
              const { original } = row;
              const { categorie, produit, name } = original;
              /*
                  categorie : "Charges d'exploitation"
                  categorieId : 3
                  isProfit : false
                  montantEcart : -8.88
                  montantPrevisionnel : -8.88
                  montantRealise : 0
                  produit : "Banque"
                  produitId : 24
                  week : "14"
                */
              return (
                <CellProduitName
                  categorie={categorie}
                  produit={produit}
                  name={name}
                />
              );
            }
          }
        ]
      },
      ...headlessWeekContents
    ],
    []
  );
}
function CellProduitName({ categorie, produit = "Non classé", name }) {
  return (
    <div className="produitContainer">
      <span className="cellName">{name}</span>
      <span className="cellProduit">{produit}</span>
    </div>
  );
}

const defaultPropGetter = () => ({});

function Table({ columns, data, weeklyTableData }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    getCellProps = defaultPropGetter,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    rows,
    prepareRow
  } = useTable({
    columns,
    data
  });

  // Render the UI for your table
  return (
    <table {...getTableProps()} style={{ width: "100%", minWidth: 1000 }}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th
                // Return an array of prop objects and react-table will merge them appropriately
                {...column.getHeaderProps([
                  {
                    colSpan: column.colSpan,
                    className: column.className,
                    style: column.style
                  },
                  getColumnProps(column),
                  getHeaderProps(column)
                ])}
              >
                {column.render("Header")}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                const { colSpan, className } = cell.column;
                return (
                  <td className={className} colspan={colSpan}>
                    {cell.render("Cell")}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

function TableFrequences({ data }) {
  const weekContents = [];
  const headlessWeekContents = [];

  const weeklyTableData = new Map();
  const tableData = new Map();
  data.forEach(line => {
    if (!tableData.has(line.produitId))
      tableData.set(line.produitId, new Map());

    console.log("<🥴");
    console.log({ line });
    weeklyTableData.set(
      `${line.week}-${moment(line.date).year()}-${line.name}`,
      line
    );

    console.log({ line });
    tableData.get(line.produitId).set(`${line.name}`, { ...line });
  });

  const date = moment();

  for (let iWeek = 0; iWeek < 4; iWeek += 1) {
    const week = moment(date).add(iWeek, "week");

    let colRealiseEcart;

    if (false) {
      //moment(date).isAfter(moment())
      colRealiseEcart = [
        {
          Header: "Réalisé",
          accessor: `realise-semaine-${week.week()}`
        },
        {
          Header: "Écart",
          accessor: `delta-semaine-${week.week()}`
        }
      ];
    } else {
      colRealiseEcart = [
        {
          Header: "",
          colSpan: 2,
          accessor: `realise-semaine-${week.week()}`
        }
      ];
    }

    weekContents.push({
      Header: `Semaine ${week.week()}`,
      className: "semaine",
      accessor: `week-${week.week()}`,
      colSpan: 2,
      columns: [
        {
          Header: `du ${week
            .startOf("week")
            .format("ddd. DD MMM. YYYY")} au ${week
            .endOf("week")
            .format("ddd. DD MMM. YYYY")}`,
          accessor: `start-${week.startOf("week").format("DD/MM/YYYY")}`,
          className: "dateHeader",
          colSpan: 2,
          columns: [
            {
              Header: "Prévisionnel",
              colSpan: 2,
              className: "value",
              accessor: `previ-semaine-${week.week()}`,
              Cell: ({ row }) => {
                const { original } = row;
                let displayMontant = 0;
                const { name, date, montantPrevisionnel, produitId } = original;

                if (
                  weeklyTableData.has(`${week.week()}-${week.year()}-${name}`)
                )
                  displayMontant = weeklyTableData.get(
                    `${week.week()}-${week.year()}-${name}`
                  ).montantPrevisionnel;

                return displayAmount(displayMontant, "€");
              }
            }
          ]
        }
      ]
    });

    headlessWeekContents.push({
      Header: ``,
      className: "semaine",
      accessor: `week-${week.week()}`,
      colSpan: 2,
      columns: [
        {
          Header: ``,
          accessor: `start-${week.startOf("week").format("DD/MM/YYYY")}`,
          className: "hidden",
          colSpan: 2,
          columns: [
            {
              Header: "",
              colSpan: 2,
              accessor: `previ-semaine-${week.week()}`,
              Cell: ({ row }) => {
                const { original } = row;
                let displayMontant = 0;
                const { name, date, montantPrevisionnel, produitId } = original;

                if (
                  weeklyTableData.has(`${week.week()}-${week.year()}-${name}`)
                )
                  displayMontant = weeklyTableData.get(
                    `${week.week()}-${week.year()}-${name}`
                  ).montantPrevisionnel;

                return displayAmount(displayMontant, "€");
              }
            }
          ]
        }
      ]
    });
  }

  if (!weekContents.length) return null;

  const headerColumns = React.useMemo(
    () => [
      {
        Header: "Profit",
        accessor: "profit",
        columns: [
          {
            Header: "Produit",
            accessor: "produit",
            Cell: ({ row }) => {
              const { original } = row;
              const { categorie, produit, name } = original;
              /*
                categorie : "Charges d'exploitation"
                categorieId : 3
                isProfit : false
                montantEcart : -8.88
                montantPrevisionnel : -8.88
                montantRealise : 0
                produit : "Banque"
                produitId : 24
                week : "14"
              */
              return (
                <CellProduitName
                  categorie={categorie}
                  produit={produit}
                  name={name}
                />
              );
            }
          }
        ]
      },
      ...weekContents
    ],
    []
  );

  const tableArray = Array.from(tableData.values());

  let index = 0;
  return tableArray.map(content => {
    const tableContent = Array.from(content.values());

    console.log({ content });
    return tableContent.map(line => {
      const { categorie, isProfit = false } = line;
      let usedWeekContents = headlessWeekContents;
      if (!index) {
        usedWeekContents = weekContents;
      }

      index += 1;
      const columns = prepareTable(
        categorie || "Non classé",
        isProfit,
        usedWeekContents
      );

      return (
        <Table
          getHeaderProps={column => ({
            onClick: () => alert(column.className)
          })}
          columns={columns}
          data={[line]}
          dataByDate={weeklyTableData}
        />
      );
    });
  });
}

export default TableFrequences;
